// extracted by mini-css-extract-plugin
export default {"container":"Oh5n_C","square":"X2QIBp","wide":"myWmwI"};